export const emailPreferencesTypes = {
  REFERENCE_COMPLETE: "REFERENCE_COMPLETE",
  RTR_READY_FOR_REVIEW: "RTR_READY_FOR_REVIEW",
  CONNECTION_ALERTS: "CONNECTION_ALERTS",
};
